// extracted by mini-css-extract-plugin
export default {"container":"styles_container__srKBv","content":"styles_content__5GMpD","logoContainer":"styles_logoContainer__mIfOC"};